








import { Component, Prop, Vue } from 'vue-property-decorator'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import { env } from '@ivy/fts/envInfo/envInfo'
import RichText from '@ivy/fts/comps/RichText.vue'

@Component({
  components: {
    RichText,
  },
})
export default class RulePanel extends Vue {
  @Prop({ default: '' }) rules: any
  close() {
    closeAll()
  }
}
